<template>
	<div class="fullscreen-centered always-on-top dark-stars">
		<div>
			<div class="scanner-users">
				<h4 class="user-name">You're All Set!</h4>
			</div>
			<div class="button-row">
				<button class="better-mobile-btn green" @click="done">Done</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SubmittedParty',
	methods: {
		done() {
			this.$emit("done")
		}
	}
}
</script>

<style scoped>

</style>